<p-accordionTab>
    <p-header>
        <div class="ui-helper-clearfix">
            <div class="left">
                <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Fixed Report Information (AT+GTFRI)</span>
            </div>
        </div>
    </p-header>

    <div class="ui-g">
        <div class="ui-g-12">
            <p-accordionTab [selected]="true">
                <p-header>
                    <div class="ui-helper-clearfix">
                        <div class="left">
                            <span class="ui-panel-title"
                                style="font-size:16px;display:inline-block;margin-top:2px">Basic Settings</span>
                        </div>
                    </div>
                </p-header>

                <div class="col row dvcFields">
                    <div class="col lblStyle">
                        <form-input fieldName="Mode">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                            <p-dropdown [options]="modeOptions" [(ngModel)]="friParameters.mode"
                                [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
                        </div>
                    </div>
                </div>
            </p-accordionTab>
        </div>
        <div class="ui-g-12">
            <p-accordionTab [selected]="true">
                <p-header>
                    <div class="ui-helper-clearfix">
                        <div class="left">
                            <span class="ui-panel-title"
                                style="font-size:16px;display:inline-block;margin-top:2px">Report Settings</span>
                        </div>
                    </div>
                </p-header>
                <div class="row align-items-center">

                    <div class="col row dvcFields">
                        <div class="col lblStyle">
                            <form-input fieldName="IGN Report Interval">
                            </form-input>
                        </div>
                        <div class="col">
                            <div class="ui-inputgroup">
                                <p-spinner size="5" step="1" [(ngModel)]="friParameters.ignReportInterval" [min]="5"
                                    [max]="86400"></p-spinner>
                                <span class="ui-inputgroup-addon">5~86400</span>
                                <span class="ui-inputgroup-addon">sec</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center">    
                    <div class="col row dvcFields">
                        <div class="col lblStyle">
                            <form-input fieldName="IGF Report Interval">
                            </form-input>
                        </div>
                        <div class="col">
                            <div class="ui-inputgroup">
                                <p-spinner size="5" step="1" [(ngModel)]="friParameters.igfReportInterval" [min]="0"
                                    [max]="86400"></p-spinner>
                                <span class="ui-inputgroup-addon">0~86400</span>
                                <span class="ui-inputgroup-addon">sec</span>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row align-items-center">    
                    <div class="col row dvcFields">
                        <div class="col lblStyle">
                            <form-input fieldName="Mileage">
                            </form-input>
                        </div>
                        <div class="col">
                            <div class="ui-inputgroup">
                                <p-spinner size="5" step="1" [(ngModel)]="friParameters.mileage" [min]="1"
                                    [max]="86400"></p-spinner>
                                <span class="ui-inputgroup-addon">50~65535</span>
                                <span class="ui-inputgroup-addon">m</span>
                            </div>
                        </div>
                    </div>

                </div>
            </p-accordionTab>
        </div>    

        <div class="ui-g-12">
            <p-accordionTab [selected]="true">
                <p-header>
                    <div class="ui-helper-clearfix">
                        <div class="left">
                            <span class="ui-panel-title"
                                style="font-size:16px;display:inline-block;margin-top:2px">Other Settings</span>
                        </div>
                    </div>
                </p-header>

                <div class="row align-items-center">
                    <div class="col">
                        <p-checkbox binary="true" label="Discard no Fix" [(ngModel)]="friParameters.discardNoFix">
                        </p-checkbox>
                    </div>
                </div>

                <div class="row align-items-center">
                    <form-input fieldName="ERI Mask"></form-input>
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="For on-board temperature" [(ngModel)]="friParameters.temperature">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="Bike Status" [(ngModel)]="friParameters.bikeStatus">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="ECU Lock State" [(ngModel)]="friParameters.ecuLockState">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="For the <RAT and Band Data> field in +RESP:GTERI" [(ngModel)]="friParameters.ratAndBand">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
            </p-accordionTab>
        </div>
    </div>
</p-accordionTab>